if (!customElements.get('sumitomo-hero-carousel')) {
  customElements.define(
    'sumitomo-hero-carousel',
    class SumitomoHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = this.querySelectorAll('[data-carousel-slide]');
        this.dots = this.querySelectorAll('[data-carousel-dot]');
        this.current = 0;
        this.timer = null;
        this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 6000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelectorAll('[data-video-toggle]').forEach((btn) => {
          const video = btn.closest('[data-carousel-slide]')?.querySelector('video');
          if (!video) return;
          const show = () => {
            const paused = video.paused;
            btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
            btn.classList.toggle('is-paused', paused);
          };
          video.addEventListener('play', show);
          video.addEventListener('pause', show);
          btn.addEventListener('click', () => (video.paused ? video.play() : video.pause()));
          if (this.reducedMotion) {
            video.removeAttribute('autoplay');
            video.pause();
          }
        });

        if (this.slides.length < 2) return;

        this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.userGo(this.current - 1));
        this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.userGo(this.current + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.userGo(i)));

        let startX = 0;
        this.track.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.track.addEventListener(
          'touchend',
          (e) => {
            const diff = startX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) this.userGo(this.current + (diff > 0 ? 1 : -1));
          },
          { passive: true }
        );

        // Theme editor: jump to the slide whose block is selected, and don't
        // auto-rotate away from it while the merchant is editing.
        document.addEventListener('shopify:block:select', (e) => {
          if (!this.contains(e.target)) return;
          this.stopAuto();
          this.go([...this.slides].indexOf(e.target));
        });
        document.addEventListener('shopify:block:deselect', (e) => {
          if (this.contains(e.target)) this.startAuto();
        });

        this.startAuto();
      }

      disconnectedCallback() {
        this.stopAuto();
      }

      go(n) {
        this.current = (n + this.slides.length) % this.slides.length;
        this.track.style.transform = `translateX(-${this.current * 100}%)`;
        this.dots.forEach((dot, i) => dot.classList.toggle('active', i === this.current));
      }

      userGo(n) {
        this.stopAuto();
        this.go(n);
        this.startAuto();
      }

      startAuto() {
        if (this.reducedMotion) return;
        this.stopAuto();
        this.timer = setInterval(() => this.go(this.current + 1), this.autoplayDelay);
      }

      stopAuto() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }
    }
  );
}
